var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-avatar',{staticClass:"profile-pic",style:({
    background: _vm.getColor({ name: _vm.name }),
    cursor: _vm.clickable ? 'pointer' : 'auto',
    'border-radius': _vm.radius ? (_vm.radius + "px") : '12px',
  }),attrs:{"size":_vm.size},on:{"click":_vm.onClick}},[(_vm.url && _vm.url !== '')?_c('img',{attrs:{"src":_vm.url,"alt":_vm.name}}):(!_vm.url && _vm.name)?_c('span',[_vm._v(_vm._s(_vm._f("filterName")(_vm.name.toUpperCase())))]):_c('span',[_vm._v("+"+_vm._s(_vm.count - 3))])])}
var staticRenderFns = []

export { render, staticRenderFns }